var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.875","y":"2.5","width":"7.07107","height":"0.883884","transform":"rotate(45 2.875 2.5)","fill":"#1A8F50","key":0}),React.createElement("rect",{"width":"7.07107","height":"0.883884","transform":"matrix(-0.707107 0.707107 0.707107 0.707107 7.25 2.5)","fill":"#1A8F50","key":1})]);
}

CloseInline.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
